var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"d-flex align-center gap-12 ga-3 text-center"},[_c('v-divider'),_vm._t("default",function(){return [_c('p',{staticClass:"opacity-70 pb-1"},[_vm._v(_vm._s(_vm.text))])]}),_c('v-divider')],2)
}
var staticRenderFns = []

export { render, staticRenderFns }